module.exports = __webpack_public_path__ + "static/media/ic_audio_disable_small_transparent.363cf550.svg";